module.exports = __webpack_public_path__ + "img/upiMax.29c13619.png";